"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBotOrdersTickerWebsocket = exports.BotOrderWebSocketObservable = void 0;
const react_1 = require("react");
const operators_1 = require("rxjs/operators");
const TradeAPILib_1 = require("TradeAPILib");
const arbitrageTypes = [TradeAPILib_1.ExchangeOrderType.cm_fsa, TradeAPILib_1.ExchangeOrderType.fsa];
function BotOrderWebSocketObservable(OrderWebsocketObserve, market, orderTypes = "all") {
    return OrderWebsocketObserve(market).pipe((0, operators_1.filter)((result) => {
        if (arbitrageTypes.some((a) => a === result.orderType)) {
            return false;
        }
        if (market !== result.exchange) {
            return false;
        }
        if (orderTypes === "all") {
            return true;
        }
        if (orderTypes.some((item) => item === result.orderType)) {
            return true;
        }
        if (orderTypes.length) {
            if (orderTypes.some((item) => item === result.orderType)) {
                return true;
            }
        }
        return false;
    }), (0, operators_1.distinctUntilChanged)((obj1, obj2) => {
        if (obj1.id === obj2.id) {
            if (obj1.orderType === obj2.orderType) {
                switch (obj2.orderType) {
                    case TradeAPILib_1.ExchangeOrderType.grid:
                        return (obj1.state === obj2.state &&
                            obj1.exchangeGridOrder.totalInvest === obj2.exchangeGridOrder.totalInvest &&
                            obj1.exchangeGridOrder.transactionAmount === obj2.exchangeGridOrder.transactionAmount &&
                            obj1.closeTimestamp === obj2.closeTimestamp &&
                            obj1.exchangeGridOrder.latestBaseAmount === obj2.exchangeGridOrder.latestBaseAmount &&
                            obj1.exchangeGridOrder.latestQuoteAmount === obj2.exchangeGridOrder.latestQuoteAmount);
                    case TradeAPILib_1.ExchangeOrderType.ig:
                        return (obj1.state === obj2.state &&
                            obj1.innerStatus === obj2.innerStatus && //开单loading使用
                            obj1.exchangeIGOrder.totalInvest === obj2.exchangeIGOrder.totalInvest &&
                            obj1.exchangeIGOrder.transactionAmount === obj2.exchangeIGOrder.transactionAmount &&
                            obj1.closeTimestamp === obj2.closeTimestamp &&
                            obj1.exchangeIGOrder.latestBaseAmount === obj2.exchangeIGOrder.latestBaseAmount &&
                            obj1.exchangeIGOrder.latestQuoteAmount === obj2.exchangeIGOrder.latestQuoteAmount);
                    case TradeAPILib_1.ExchangeOrderType.gridV3:
                        return (obj1.state === obj2.state &&
                            obj1.exchangeGridV3Order.totalInvest === obj2.exchangeGridV3Order.totalInvest &&
                            obj1.exchangeGridV3Order.trx_history === obj2.exchangeGridV3Order.trx_history &&
                            obj1.closeTimestamp === obj2.closeTimestamp &&
                            obj1.exchangeGridV3Order.triggerTime === obj2.exchangeGridV3Order.triggerTime &&
                            obj1.innerStatus === obj2.innerStatus &&
                            obj1.exchangeGridV3Order.baseAmount === obj2.exchangeGridV3Order.baseAmount &&
                            obj1.exchangeGridV3Order.quoteAmount === obj2.exchangeGridV3Order.quoteAmount &&
                            //下列为提取利润相关
                            obj1.exchangeGridV3Order.profitWithdrawn === obj2.exchangeGridV3Order.profitWithdrawn &&
                            obj1.exchangeGridV3Order.latestQuoteAmount === obj2.exchangeGridV3Order.latestQuoteAmount &&
                            obj1.exchangeGridV3Order.baseFeeReserve === obj2.exchangeGridV3Order.baseFeeReserve &&
                            obj1.exchangeGridV3Order.quoteFeeReserve === obj2.exchangeGridV3Order.quoteFeeReserve);
                    case TradeAPILib_1.ExchangeOrderType.gridV4:
                        return (obj1.state === obj2.state &&
                            obj1.exchangeGridV4Order.totalInvest === obj2.exchangeGridV4Order.totalInvest &&
                            obj1.exchangeGridV4Order.trx_history === obj2.exchangeGridV4Order.trx_history &&
                            obj1.closeTimestamp === obj2.closeTimestamp &&
                            obj1.exchangeGridV4Order.triggerTime === obj2.exchangeGridV4Order.triggerTime &&
                            obj1.innerStatus === obj2.innerStatus &&
                            obj1.exchangeGridV4Order.baseAmount === obj2.exchangeGridV4Order.baseAmount &&
                            obj1.exchangeGridV4Order.quoteAmount === obj2.exchangeGridV4Order.quoteAmount &&
                            //下列为提取利润相关
                            obj1.exchangeGridV4Order.profitWithdrawn === obj2.exchangeGridV4Order.profitWithdrawn &&
                            obj1.exchangeGridV4Order.latestQuoteAmount === obj2.exchangeGridV4Order.latestQuoteAmount &&
                            obj1.exchangeGridV4Order.baseFeeReserve === obj2.exchangeGridV4Order.baseFeeReserve &&
                            obj1.exchangeGridV4Order.quoteFeeReserve === obj2.exchangeGridV4Order.quoteFeeReserve);
                    case TradeAPILib_1.ExchangeOrderType.gridPro:
                        return (obj1.state === obj2.state &&
                            obj1.exchangeGridProOrder.totalInvest === obj2.exchangeGridProOrder.totalInvest &&
                            obj1.exchangeGridProOrder.trx_history === obj2.exchangeGridProOrder.trx_history &&
                            obj1.closeTimestamp === obj2.closeTimestamp &&
                            obj1.exchangeGridProOrder.triggerTime === obj2.exchangeGridProOrder.triggerTime &&
                            obj1.innerStatus === obj2.innerStatus &&
                            obj1.exchangeGridProOrder.baseAmount === obj2.exchangeGridProOrder.baseAmount &&
                            obj1.exchangeGridProOrder.quoteAmount === obj2.exchangeGridProOrder.quoteAmount &&
                            //下列为提取利润相关
                            obj1.exchangeGridProOrder.profitWithdrawn === obj2.exchangeGridProOrder.profitWithdrawn &&
                            obj1.exchangeGridProOrder.latestQuoteAmount === obj2.exchangeGridProOrder.latestQuoteAmount &&
                            obj1.exchangeGridProOrder.baseFeeReserve === obj2.exchangeGridProOrder.baseFeeReserve &&
                            obj1.exchangeGridProOrder.quoteFeeReserve === obj2.exchangeGridProOrder.quoteFeeReserve);
                    case TradeAPILib_1.ExchangeOrderType.gridClassic:
                        return (obj1.state === obj2.state &&
                            obj1.exchangeGridClassicOrder.totalInvest === obj2.exchangeGridClassicOrder.totalInvest &&
                            obj1.exchangeGridClassicOrder.trx_history === obj2.exchangeGridClassicOrder.trx_history &&
                            obj1.closeTimestamp === obj2.closeTimestamp &&
                            obj1.exchangeGridClassicOrder.triggerTime === obj2.exchangeGridClassicOrder.triggerTime &&
                            obj1.innerStatus === obj2.innerStatus &&
                            obj1.exchangeGridClassicOrder.baseAmount === obj2.exchangeGridClassicOrder.baseAmount &&
                            obj1.exchangeGridClassicOrder.quoteAmount === obj2.exchangeGridClassicOrder.quoteAmount);
                    case TradeAPILib_1.ExchangeOrderType.gridLeverage:
                        return (obj1.state === obj2.state &&
                            obj1.exchangeLeverageGridOrder.totalInvest === obj2.exchangeLeverageGridOrder.totalInvest &&
                            obj1.exchangeLeverageGridOrder.trx_history === obj2.exchangeLeverageGridOrder.trx_history &&
                            obj1.closeTimestamp === obj2.closeTimestamp &&
                            obj1.exchangeLeverageGridOrder.liquidatedTriggered ===
                                obj2.exchangeLeverageGridOrder.liquidatedTriggered &&
                            obj1.exchangeLeverageGridOrder.triggerTime === obj2.exchangeLeverageGridOrder.triggerTime &&
                            obj1.exchangeLeverageGridOrder.liquidatedPrice === obj2.exchangeLeverageGridOrder.liquidatedPrice &&
                            obj1.innerStatus === obj2.innerStatus &&
                            obj1.exchangeLeverageGridOrder.baseAmount === obj2.exchangeLeverageGridOrder.baseAmount &&
                            obj1.exchangeLeverageGridOrder.quoteAmount === obj2.exchangeLeverageGridOrder.quoteAmount &&
                            obj1.exchangeLeverageGridOrder.loanCoin === obj2.exchangeLeverageGridOrder.loanCoin);
                    case TradeAPILib_1.ExchangeOrderType.gridLeverageShort:
                        return (obj1.state === obj2.state &&
                            obj1.exchangeLeverageShortGridOrder.totalInvest === obj2.exchangeLeverageShortGridOrder.totalInvest &&
                            obj1.exchangeLeverageShortGridOrder.trx_history === obj2.exchangeLeverageShortGridOrder.trx_history &&
                            obj1.closeTimestamp === obj2.closeTimestamp &&
                            obj1.exchangeLeverageShortGridOrder.liquidatedTriggered ===
                                obj2.exchangeLeverageShortGridOrder.liquidatedTriggered &&
                            obj1.exchangeLeverageShortGridOrder.triggerTime === obj2.exchangeLeverageShortGridOrder.triggerTime &&
                            obj1.exchangeLeverageShortGridOrder.liquidatedPrice ===
                                obj2.exchangeLeverageShortGridOrder.liquidatedPrice &&
                            obj1.innerStatus === obj2.innerStatus &&
                            obj1.exchangeLeverageShortGridOrder.baseAmount === obj2.exchangeLeverageShortGridOrder.baseAmount &&
                            obj1.exchangeLeverageShortGridOrder.quoteAmount === obj2.exchangeLeverageShortGridOrder.quoteAmount &&
                            obj1.exchangeLeverageShortGridOrder.loanCoin === obj2.exchangeLeverageShortGridOrder.loanCoin);
                    case TradeAPILib_1.ExchangeOrderType.gridFuture:
                        return (obj1.state === obj2.state &&
                            obj1.exchangeFutureGridOrder.totalInvest === obj2.exchangeFutureGridOrder.totalInvest &&
                            obj1.exchangeFutureGridOrder.trx_history === obj2.exchangeFutureGridOrder.trx_history &&
                            obj1.closeTimestamp === obj2.closeTimestamp &&
                            obj1.exchangeFutureGridOrder.liquidatedTriggered === obj2.exchangeFutureGridOrder.liquidatedTriggered &&
                            obj1.exchangeFutureGridOrder.triggerTime === obj2.exchangeFutureGridOrder.triggerTime &&
                            obj1.exchangeFutureGridOrder.liquidatedPrice === obj2.exchangeFutureGridOrder.liquidatedPrice &&
                            obj1.innerStatus === obj2.innerStatus &&
                            obj1.exchangeFutureGridOrder.baseAmount === obj2.exchangeFutureGridOrder.baseAmount &&
                            obj1.exchangeFutureGridOrder.quoteAmount === obj2.exchangeFutureGridOrder.quoteAmount);
                    case TradeAPILib_1.ExchangeOrderType.gridLoan:
                        return (obj1.state === obj2.state &&
                            obj1.exchangeLoanGridOrder.totalInvest === obj2.exchangeLoanGridOrder.totalInvest &&
                            obj1.exchangeLoanGridOrder.trx_history === obj2.exchangeLoanGridOrder.trx_history &&
                            obj1.closeTimestamp === obj2.closeTimestamp &&
                            obj1.exchangeLoanGridOrder.liquidatedTriggered === obj2.exchangeLoanGridOrder.liquidatedTriggered &&
                            obj1.exchangeLoanGridOrder.triggerTime === obj2.exchangeLoanGridOrder.triggerTime &&
                            obj1.exchangeLoanGridOrder.liquidatedPrice === obj2.exchangeLoanGridOrder.liquidatedPrice &&
                            obj1.innerStatus === obj2.innerStatus &&
                            obj1.exchangeLoanGridOrder.baseAmount === obj2.exchangeLoanGridOrder.baseAmount &&
                            obj1.exchangeLoanGridOrder.quoteAmount === obj2.exchangeLoanGridOrder.quoteAmount &&
                            obj1.exchangeLoanGridOrder.loanCoin === obj2.exchangeLoanGridOrder.loanCoin);
                    case TradeAPILib_1.ExchangeOrderType.gridShort:
                        return (obj1.state === obj2.state &&
                            obj1.exchangeShortGridOrder.totalInvest === obj2.exchangeShortGridOrder.totalInvest &&
                            obj1.exchangeShortGridOrder.trx_history === obj2.exchangeShortGridOrder.trx_history &&
                            obj1.closeTimestamp === obj2.closeTimestamp &&
                            obj1.exchangeShortGridOrder.triggerTime === obj2.exchangeShortGridOrder.triggerTime &&
                            obj1.innerStatus === obj2.innerStatus &&
                            obj1.exchangeShortGridOrder.baseAmount === obj2.exchangeShortGridOrder.baseAmount &&
                            obj1.exchangeShortGridOrder.quoteAmount === obj2.exchangeShortGridOrder.quoteAmount &&
                            //下列为提取利润相关
                            obj1.exchangeShortGridOrder.profitWithdrawn === obj2.exchangeShortGridOrder.profitWithdrawn &&
                            obj1.exchangeShortGridOrder.latestQuoteAmount === obj2.exchangeShortGridOrder.latestQuoteAmount &&
                            obj1.exchangeShortGridOrder.baseFeeReserve === obj2.exchangeShortGridOrder.baseFeeReserve &&
                            obj1.exchangeShortGridOrder.quoteFeeReserve === obj2.exchangeShortGridOrder.quoteFeeReserve);
                    default:
                        return false;
                }
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }));
}
exports.BotOrderWebSocketObservable = BotOrderWebSocketObservable;
const withoutExchangeInfoOrderType = [TradeAPILib_1.ExchangeOrderType.market, TradeAPILib_1.ExchangeOrderType.limit];
function useBotOrdersTickerWebsocket(exchange, data, subscribeTicker, focus = true) {
    const tickerMapCache = (0, react_1.useRef)(new Map());
    const [tickerMap, changeTickerMap] = (0, react_1.useState)(new Map());
    const lastList = (0, react_1.useRef)([]);
    const symbolPairList = (0, react_1.useMemo)(() => {
        if (!exchange || !data || !data.length) {
            return;
        }
        let addNew = false;
        const symbolListResult = lastList.current;
        data.forEach((item) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            if (withoutExchangeInfoOrderType.some((a) => a === item.orderType)) {
                if (!symbolListResult.some((v) => v.base === item.base && v.quote === item.quote && v.market === exchange)) {
                    addNew = true;
                    symbolListResult.push({
                        base: item.base,
                        quote: item.quote,
                        market: exchange,
                    });
                }
            }
            else if (item.orderType === TradeAPILib_1.ExchangeOrderType.SR) {
                (_a = item.exchangeSROrder) === null || _a === void 0 ? void 0 : _a.coins.forEach((item1) => {
                    if (!symbolListResult.some((v) => v.base === item1.base && v.quote === item.quote && v.market === item.exchange)) {
                        addNew = true;
                        symbolListResult.push({
                            base: item1.base,
                            quote: item.quote,
                            market: item.exchange || exchange,
                        });
                    }
                });
            }
            else if (item.orderType === TradeAPILib_1.ExchangeOrderType.martingale) {
                (_b = item.exchangeMTGOrder) === null || _b === void 0 ? void 0 : _b.coins.forEach((item1) => {
                    if (!symbolListResult.some((v) => v.base === item1.base && v.quote === item.quote && v.market === item.exchange)) {
                        addNew = true;
                        symbolListResult.push({
                            base: item1.base,
                            quote: item.quote,
                            market: item.exchange || exchange,
                        });
                    }
                });
            }
            else if (item.orderType === TradeAPILib_1.ExchangeOrderType.futures_martingale) {
                (_d = (_c = item.exchangeMTGFuturesOrder) === null || _c === void 0 ? void 0 : _c.portfolio) === null || _d === void 0 ? void 0 : _d.forEach((item1) => {
                    if (!symbolListResult.some((v) => v.base === item1.base && v.quote === item.quote && v.market === item.exchange)) {
                        addNew = true;
                        symbolListResult.push({
                            base: item1.base,
                            quote: item.quote,
                            market: item.exchange || exchange,
                        });
                    }
                });
            }
            else if (item.orderType === TradeAPILib_1.ExchangeOrderType.SC) {
                (_e = item.exchangeSCOrder) === null || _e === void 0 ? void 0 : _e.coins.forEach((item1) => {
                    if (!symbolListResult.some((v) => v.base === item1.base && v.quote === item.quote && v.market === item.exchange)) {
                        addNew = true;
                        symbolListResult.push({
                            base: item1.base,
                            quote: item.quote,
                            market: item.exchange || exchange,
                        });
                    }
                });
            }
            else {
                if (!symbolListResult.some((v) => v.base === item.base && v.quote === item.quote && v.market === item.exchange)) {
                    addNew = true;
                    symbolListResult.push({
                        base: item.base,
                        quote: item.quote,
                        market: item.exchange || exchange,
                    });
                }
            }
            if (item.orderType === TradeAPILib_1.ExchangeOrderType.fsa) {
                if (!symbolListResult.some((v) => {
                    var _a, _b, _c;
                    return v.base === ((_a = item.exchangeFSAOrder) === null || _a === void 0 ? void 0 : _a.swapBase) &&
                        v.quote === ((_b = item.exchangeFSAOrder) === null || _b === void 0 ? void 0 : _b.swapQuote) &&
                        v.market === ((_c = item.exchangeFSAOrder) === null || _c === void 0 ? void 0 : _c.swapExchange);
                })) {
                    addNew = true;
                    symbolListResult.push({
                        base: ((_f = item.exchangeFSAOrder) === null || _f === void 0 ? void 0 : _f.swapBase) || "",
                        quote: ((_g = item.exchangeFSAOrder) === null || _g === void 0 ? void 0 : _g.swapQuote) || "",
                        market: ((_h = item.exchangeFSAOrder) === null || _h === void 0 ? void 0 : _h.swapExchange) || "",
                    });
                }
            }
            if (item.orderType === TradeAPILib_1.ExchangeOrderType.cm_fsa) {
                if (!symbolListResult.some((v) => {
                    var _a, _b, _c;
                    return v.base === ((_a = item.exchangeCMFSAOrder) === null || _a === void 0 ? void 0 : _a.swapBase) &&
                        v.quote === ((_b = item.exchangeCMFSAOrder) === null || _b === void 0 ? void 0 : _b.swapQuote) &&
                        v.market === ((_c = item.exchangeCMFSAOrder) === null || _c === void 0 ? void 0 : _c.swapExchange);
                })) {
                    addNew = true;
                    symbolListResult.push({
                        base: ((_j = item.exchangeCMFSAOrder) === null || _j === void 0 ? void 0 : _j.swapBase) || "",
                        quote: ((_k = item.exchangeCMFSAOrder) === null || _k === void 0 ? void 0 : _k.swapQuote) || "",
                        market: ((_l = item.exchangeCMFSAOrder) === null || _l === void 0 ? void 0 : _l.swapExchange) || "",
                    });
                }
            }
        });
        lastList.current = symbolListResult;
        return symbolListResult;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.length, exchange]);
    (0, react_1.useEffect)(() => {
        if (!(symbolPairList === null || symbolPairList === void 0 ? void 0 : symbolPairList.length) || !focus || !subscribeTicker) {
            return;
        }
        let subscription;
        subscription = subscribeTicker(symbolPairList)
            .pipe((0, operators_1.throttleTime)(1000))
            .subscribe({
            next: (tickerList) => {
                tickerList.forEach((item) => {
                    var _a;
                    const identify = `${(_a = item.exchange) !== null && _a !== void 0 ? _a : ""}/${item.base}/${item.quote}`;
                    tickerMapCache.current.set(identify, item);
                });
                changeTickerMap(new Map(tickerMapCache.current));
            },
            error: (error) => { },
        });
        return () => subscription && subscription.unsubscribe();
    }, [symbolPairList, focus, subscribeTicker]);
    return tickerMap;
}
exports.useBotOrdersTickerWebsocket = useBotOrdersTickerWebsocket;
